import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectPendingPaymentIds } from 'libs/billing/pending-payment/data-access/src/lib/+state/pending-payment.selectors';
import { selectPolicies } from 'libs/policy/data-access/src/lib/+state/policies/policies.selectors';

import { BillAccountsSelectors } from '@amfam/billing/billaccount/data-access';
import { SourceSystem } from '@amfam/policy/models';

import * as fromOneTimePayState from './one-time-pay-feature.reducer';

export const ONE_TIME_PAY_FEATURE_KEY = 'oneTimePay';

export const selectOneTimePayState = createFeatureSelector<fromOneTimePayState.State>(
  fromOneTimePayState.oneTimePayFeatureKey
);

export const selectOneTimePayCancelPath = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) => state.cancelPathUrl
);

export const selectOneTimePayEntities = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) => state.entities
);

export const selectOneTimePayOperation = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) =>
    <'Success' | 'Error' | 'Delete-Success' | 'Delete-Error'>state.operation
);

export const selectOneTimePayAnalyticsPaymentAmt = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) => state.paymentAmtAnalytics
);

export const selectOneTimePayAnalyticsPaymentDate = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) => state.paymentDateAnalytics
);

export const selectPaymentId = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) => state.paymentId
);

export const selectPaymentErrorCode = createSelector(
  selectOneTimePayState,
  (state: fromOneTimePayState.State) => state.paymentErrorCode
);

export const selectBillingAccounts = createSelector(
  selectPendingPaymentIds,
  preselectedAccounts => preselectedAccounts
);

export const selectIsPolicyPhoenix = (billAccountNumber: string) =>
  createSelector(
    BillAccountsSelectors.selectBillAccount(billAccountNumber),
    selectPolicies,
    (billingAccount, policies) =>
      !!policies.find(
        policy =>
          policy.policyNumber === billingAccount.policyList[0].policyNumber &&
          policy.sourcePath === SourceSystem.PHOENIX
      )
  );
